export const english = {
    completed: 'Completed',
    title: 'Health Screening Self-Reporting Form',
    measurementYear: '2024 Measurement Year',
    alignmentMessageTitle: 'A Message from Alignment Health',
    alignmentMessage1: 'Dear {name}, your well-being is our top priority. Preventive screenings are essential to maintaining good health and catching potential issues early. By completing your recommended screenings, you\'re taking an important step in protecting your health and ensuring peace of mind.',
    alignmentMessage2: 'As a token of our appreciation, you\'ll receive **$30 for each completed screening** in 2024! You will have another opportunity to earn rewards for 2025.',
    alignmentMessage3: 'As a token of our appreciation, you\'ll receive **$30 for each completed screening** in 2024! You will have another opportunity to earn rewards for 2025.',
    alignmentMessage4: `Hakan Kardes
Chief Experience Officer
Alignment Health Plan
    `,
    tokenError: 'There is an error with your token',
    thankYou: `Thank you. Your responses have been submitted.
    You will now be redirected to Alignment
    Health Plan Member Portal.`,
    thankYouOK: 'OK',
    breastCancerTitle: 'Breast Cancer Screening (mammogram between 10/01/2022 - 12/31/2024)',
    select: 'Select.',
    yes: 'Yes',
    no: 'No',
    enterYear: 'Enter year.',
    enterMonth: 'Enter month.',
    colorectalTitle: ' Colorectal Cancer Screening (between 01/01/2015 and 12/31/2024)',
    colonoscopy: 'Colonoscopy (between 01/01/2015 and 12/31/2024)',
    stoolTest: 'Stool Test (FIT/FOBT any time in 2024)',
    cologuard: 'Cologuard (between 01/01/2022 and 12/31/2024)',
    bloodPressureTestTitle: 'Blood Pressure Check (most recent reading in 2024, must be under 140/90)',
    bloodPressureEnterMostRecentReading: 'Enter most recent reading in 2024, must be under 140/90',
    needAnyHelp: 'Do you need help scheduling any screenings in 2025?',
    iConfirm: 'I confirm that the information provided is accurate and may be used to update my medical records.',
    send: 'Enviar',
    submitError: 'We\'re sorry, there was an issue while submitting your answers. Please try againlater.'
};